import styled from "styled-components";

export const Wrapper = styled.div`

`;

export const Content = styled.div`
    margin: 60px;
    font-family: "Roboto";
`;